export const SportViews = {
  eu: 'europeanView',
  af: 'africanView',
  as: 'AsianView',
  m: 'Mobile',
  es: 'ESport',
  la: 'LatinoView',
}

export const iframeSportViews = ['europeanView', 'africanView']

export const mobileSportViews = ['Mobile', 'ESport']

export const desktopSportViews = ['europeanView', 'africanView', 'AsianView', 'ESport', 'LatinoView']

export type SportViewType = keyof typeof SportViews

const pages = [
  'Home',
  'Upcoming',
  'EventView',
  'Results',
  'UpcomingDetails',
  'Calendar',
  'MultiView',
  'BetsHistory',
  'GroupStage',
  'Live',
  'Overview',
  'Sport',
  'SportEvents',
] as const

export enum IPagesEnum {
  'Home',
  'Upcoming',
  'EventView',
  'Results',
  'UpcomingDetails',
  'Calendar',
  'MultiView',
  'Overview',
  'BetsHistory',
  'GroupStage',
  'Live',
  'Sport',
  'SportEvents',
}

export type PageTypes = (typeof pages)[number]

export const convertedPagesByViews: { [viewKey in SportViewType]?: { [pageKey in PageTypes]?: string } } = {
  eu: {
    Live: 'Overview',
  },
  af: { Live: 'Overview' },
  as: { Live: 'Overview' },
  es: { Live: 'Overview' },
  la: { Live: 'Overview' },
  m: { UpcomingDetails: 'Events', Upcoming: 'SportEvents' },
}

export enum SportIds {
  Footbal = 1,
  'Water Polo' = 2,
  Tennis = 3,
  Basketball = 4,
  Baseball = 5,
  'American Football' = 6,
  Boxing = 7,
  Golf = 8,
  Chess = 9,
  'Ice Hockey' = 10,
  Bandy = 11,
  Volleyball = 12,
  Handball = 13,
  'Rugby Union' = 14,
  Biathlon = 15,
  'What? Where? When?' = 16,
  Futsal = 17,
  'Formula 1' = 18,
  Snooker = 19,
  Darts = 20,
  'Field Hockey' = 21,
  'Beach Football' = 22,
  Curling = 23,
  Others = 24,
  'Table Tennis' = 25,
  'Beach Volleyball' = 26,
  'Roller Hockey' = 27,
  Eurovision = 28,
  Badminton = 29,
  'Rugby League' = 30,
  Bowls = 31,
  Squash = 32,
  Politics = 33,
  'Olympic Games' = 34,
  Specials = 35,
  Cricket = 36,
  Floorball = 37,
  Speedway = 38,
  'Aussie Rules' = 39,
  'Padel Tennis' = 40,
  Cycling = 41,
  Skiing = 42,
  'Ski Jumping' = 43,
  Yachting = 44,
  'Mini Football' = 45,
  'Martial Arts' = 46,
  Netball = 47,
  Athletics = 48,
  Judo = 49,
  Equestrian = 50,
  Softball = 51,
  'Gaelic Football' = 52,
  Esports = 53,
  Weightlifting = 54,
  Poker = 55,
  Sumo = 56,
  Gymnastics = 57,
  Taekwondo = 58,
  Pool = 59,
  Shooting = 60,
  Archery = 61,
  'Water Sports' = 62,
  Lacrosse = 63,
  Motorcycling = 64,
  Surfing = 65,
  Rally = 66,
  NASCAR = 67,
  Canoeing = 68,
  'Auto Racing' = 69,
  Lottery = 70,
  'Ski Racing' = 71,
  Greyhound = 72,
  'Horse Racing' = 73,
  Sailing = 74,
  Billiard = 75,
  Fencing = 76,
  'Pro Wrestling' = 77,
  Oscar = 78,
  Grammy = 79,
  'Basketball 3x3' = 80,
  'Table Football' = 81,
  'VDR Greyhound' = 82,
  'Modern pentathlon' = 83,
  Triathlon = 84,
  Wrestling = 85,
  'Beach Handball' = 86,
  Hurling = 87,
  'Army Games' = 88,
  'Bare-knuckle boxing' = 89,
  Kabaddi = 90,
  IndyCar = 91,
  Kickboxing = 92,
  'Sepak Takraw' = 93,
  'E-Football' = 94,
  'E-Basketball' = 95,
  'E-IceHockey' = 96,
  'E-Tennis' = 97,
  'E-NASCAR' = 98,
  'E-Volleyball' = 99,
  'Odds Booster' = 100,
  KLASK = 101,
  'Air Hockey' = 102,
  'Figure Skating' = 103,
  Pesapallo = 104,
  Karate = 105,
  Skateboarding = 106,
  'Sport Climbing' = 107,
}

export interface IToken {
  token: string
}

export type LanguageTypes =
  | 'ru'
  | 'en'
  | 'hy'
  | 'tr'
  | 'bs'
  | 'Fa'
  | 'ar'
  | 'sr'
  | 'hr'
  | 'uk'
  | 'Ku'
  | 'He'
  | 'es'
  | 'pt'
  | 'it'
  | 'fr'
  | 'de'
  | 'ko'
  | 'da'
  | 'fi'
  | 'cs'
  | 'sv'
  | 'ka'
  | 'no'
  | 'zh'
  | 'zh-CHT'

enum OddsEnum {
  'Decimal',
  'Fractional',
  'American',
  'Hong Kong',
  'Malay',
  'Indo',
}

type eventsTypes = 'successBet' | 'navigateToSport'

type eventsData = {
  id: number
  status: string
  name: string
} | null

type themesTypes = 'default' | 'alternative'

export interface INavigateCallbackProps {
  targetId: number
  pageName: string
  targetName: string
}

export interface IBalanceChangeCallbackProps {
  BonusBalance: string
  CashBackBalance: string
  TournamentBalance: string
}

export interface IEventsHandlerProps {
  sender: string
  eventType: eventsTypes
  data: eventsData
}

export interface IParametersIframe {
  server: string
  token?: Union<'-', string>
  currentPage?: string
  language?: LanguageTypes
  login?: { (): void }
  registration?: { (): void }
  timeZone?: string
  eventId?: string
  isSuperTip?: boolean
  champId?: string
  deposit?: { (): void }
  customCssUrl?: string
  oddsFormat?: OddsEnum
  oddsFormatList?: OddsEnum
  onContentLoaded?: string
  sportsBookView: (typeof iframeSportViews)[number]
  fixedHeight?: boolean
  clearSiteStyles?: boolean
  balanceChangeCallback?: { (data: IBalanceChangeCallbackProps): void }
  onNavigateCallback?: { (data: INavigateCallbackProps): void }
  getBookingNumber?: { (): void }
  eventsHandler?: { (data: IEventsHandlerProps): void }
  bookingNumber?: { (): void }
  projectTheme?: themesTypes
  parent: string[]
  destroy?: { (): void }
  userId: string
  sportPartner?: string
}

export interface IParametersNative extends IParametersIframe {
  containerId: string
  hashRouterDisabled?: boolean
  externalLinksOpenInside?: boolean
  initialRoute?: {
    path: string
  }
}
